import React, { useEffect, useState } from 'react'
import { SidebarMenuItem } from './SidebarMenuItem'
import sidebarDashboardIcon from '../../../../images/sidebarDashboard.svg'
import sidebarProductIcon from '../../../../images/sidebarproduct.svg'
import sidebarClientIcon from '../../../../images/sidebarClient.svg'
import sidebarMenuCallIcon from '../../../../images/sidebarmenucall.png'
import sidebarQCIcon from '../../../../images/sidebarQcUsers.svg'
import sidebarChannelIcon from '../../../../images/SidebarChannelIcon.svg'
import sidebarAgentIcon from '../../../../images/Sidebarmenuagent.svg'
import SidebarTPV from '../../../../images/SidebarTPV.svg'
import DoNotEnrollIcon from '../../../../images/donotenroll.svg'
import SmartDocsIcon from '../../../../images/SmartDocs-Icon.svg'
import { useParams, useNavigate } from 'react-router-dom'
import { adminRoles } from '../../../../../utils/helper'
import sidebarReportIcon from '../../../../images/reportIcon.svg'
import { useLazyQuery } from '@apollo/client'
import {
  GET_CLIENT_ALLOWED_COMPONENTS,
  GET_USER_PROFILE,
  GETCLIENTFEATUREFLAGS,
} from '../../../../../utils/GraphQLAPI'
import { GLOBAL_CONSTANTS } from '../../../../../utils/GlobalConstants'

const SidebarMenuMain = () => {
  const [sidebarMenuData, setSidebarMenuData] = useState<any>()
  const [renderSidebar, setRenderSidebar] = useState(false)
  const [smartDocs, setSmartDocs] = useState(false)
  const getUrlProps = useParams()
  const navigate = useNavigate()
  const fontIconName = 'bi-app-indicator'
  const [isLeadgen, setIsLeadgen] = useState(false)
  const [getUserProfile] = useLazyQuery(GET_USER_PROFILE, {
    onCompleted: (data) => {
      window.localStorage.setItem('userId', JSON.stringify(data?.getUserProfile?.id))
      if (data.getUserProfile.client.clientBusinessType === 'Lead Gen') {
        setIsLeadgen(true)
        navigate(`/${getUrlProps.adminUser}/customer-list`)
        localStorage.setItem('IsLeadgen', 'true')
      } else {
        setIsLeadgen(false)
        localStorage.setItem('IsLeadgen', 'false')
      }
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })

  const [agentReport, setAgentReport] = useState<any>(undefined)
  const [salesReport, setSalesReport] = useState<any>(undefined)

  const [getSparkComponents] = useLazyQuery(GET_CLIENT_ALLOWED_COMPONENTS, {
    onCompleted: (data) => {
      setAgentReport(data?.getClientAllowedComponents.includes('agentViewCustomerReport'))
      // setSalesReport(data?.getClientAllowedComponents.includes('salesAdminViewCustomerReport'))
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })
  const [getClientFeatureflags] = useLazyQuery(GETCLIENTFEATUREFLAGS, {
    onCompleted: (data) => {
      setSalesReport(data?.getClientFeatureFlags.enableCustomerReportToSalesChannel)
      setSmartDocs(data?.getClientFeatureFlags?.isSmartDocEnabled)
    },
    fetchPolicy: 'network-only',
  })
  useEffect(() => {
    getSparkComponents()
    getUserProfile()
    getClientFeatureflags()
  }, [])
  useEffect(() => {
    const role: any = getUrlProps.adminUser
    if (!isLeadgen) {
      navigateUser(role)
    }
  }, [getUrlProps, isLeadgen, agentReport, salesReport])

  useEffect(() => {
    const timer = setTimeout(() => {
      setRenderSidebar(true)
    }, 500)

    return () => clearTimeout(timer)
  }, [isLeadgen, sidebarMenuData])
  const salesSidebarContent = [
    {
      to: `/${getUrlProps.adminUser}/sales-dashboard`,
      icon: sidebarDashboardIcon,
      title: 'Dashboard',
      fontIcon: fontIconName,
    },
    {
      to: `/${getUrlProps.adminUser}/agent-leader-list`,
      icon: sidebarDashboardIcon,
      title: 'Agent Leader List',
      fontIcon: fontIconName,
    },
    {
      to: `/${getUrlProps.adminUser}/sales-agent-list`,
      icon: sidebarAgentIcon,
      title: 'Agent List',
      fontIcon: fontIconName,
    },
  ]
  const sparksalesSidebarContent = [
    ...salesSidebarContent,
    {
      to: `/${getUrlProps.adminUser}/sales-report`,
      icon: sidebarReportIcon,
      title: 'Report',
      fontIcon: fontIconName,
    },
  ]



  const systemAdminSidebarContent = [
    {
      to: `/${getUrlProps.adminUser}/dashboard`,
      icon: sidebarDashboardIcon,
      title: 'Dashboard',
      fontIcon: fontIconName,
    },
    {
      to: `/${getUrlProps.adminUser}/products`,
      icon: sidebarProductIcon,
      title: 'Products',
      fontIcon: fontIconName,
    },
    {
      to: `/${getUrlProps.adminUser}/sales-channel-list`,
      icon: sidebarChannelIcon,
      title: 'Sales Channels',
      fontIcon: fontIconName,
    },
    {
      to: `/${getUrlProps.adminUser}/qc-list`,
      icon: sidebarQCIcon,
      title: 'QC Users',
      fontIcon: fontIconName,
    },
    {
      to: `/${getUrlProps.adminUser}/tpvscript`,
      icon: SidebarTPV,
      title: 'TPV Scripts',
      fontIcon: fontIconName,
    },
    {
      to: `/${getUrlProps.adminUser}/agent-verification`,
      icon: sidebarAgentIcon,
      title: 'Agent Verification',
      fontIcon: fontIconName,
    },
    {
      to: `/${getUrlProps.adminUser}/tpv-report`,
      icon: sidebarReportIcon,
      title: 'TPV Reports',
      fontIcon: fontIconName,
    },
    {
      to: `/${getUrlProps.adminUser}/do-not-enroll`,
      icon: DoNotEnrollIcon,
      title: 'Do Not Enroll',
      fontIcon: fontIconName,
    },
    ...(smartDocs
      ? [{
        to: `/${getUrlProps.adminUser}/smart-docs`,
        icon: SmartDocsIcon,
        title: 'SmartDocs',
        fontIcon: fontIconName,
      }]
      : []),
  ]

  const agentSidebarContent = [
    {
      to: `/${getUrlProps.adminUser}/agent-dashboard`,
      icon: sidebarDashboardIcon,
      title: 'Dashboard',
      fontIcon: fontIconName,
    },
  ]
  const sparkagentSidebarContent = [
    ...agentSidebarContent,
    {
      to: `/${getUrlProps.adminUser}/agent-report`,
      icon: sidebarReportIcon,
      title: 'Report',
      fontIcon: fontIconName,
    },
  ]

  const tpvadminSidebarContent = [
    {
      to: `/${getUrlProps.adminUser}/tpv-dashboard`,
      icon: sidebarDashboardIcon,
      title: 'Dashboard',
      fontIcon: fontIconName,
    },
    {
      to: `/${getUrlProps.adminUser}/tpv-client-list`,
      icon: sidebarClientIcon,
      title: 'Client List',
      fontIcon: fontIconName,
    },
    {
      to: `/${getUrlProps.adminUser}/live-agents-list`,
      icon: sidebarClientIcon,
      title: 'Live Agents List',
      fontIcon: fontIconName,
    },
    {
      to: `/${getUrlProps.adminUser}/vendors-list`,
      icon: sidebarClientIcon,
      title: 'Vendors List',
      fontIcon: fontIconName,
    },

    {
      to: `/${getUrlProps.adminUser}/monitor`,
      icon: sidebarClientIcon,
      title: 'Monitor',
      fontIcon: fontIconName,
    },
    // {
    //   to: `/${getUrlProps.adminUser}/audit-trail`,
    //   icon: AuditIcon,
    //   title: 'Audit Trial',
    //   fontIcon: fontIconName,
    // },
  ]

  const qcAdminSidebarContent = [
    {
      to: `/${getUrlProps.adminUser}/qc-dashboard`,
      icon: sidebarDashboardIcon,
      title: 'Dashboard',
      fontIcon: fontIconName,
    },
    {
      to: `/${getUrlProps.adminUser}/tpv-recording-list`,
      icon: sidebarClientIcon, // need to set icon later
      title: 'TPV Records List',
      fontIcon: fontIconName,
    },
  ]
  const liveagentSidebarContent = [
    {
      to: `/${getUrlProps.adminUser}/liveagent-call`,
      icon: sidebarClientIcon,
      title: 'Live Agent Call',
      fontIcon: fontIconName,
    },
    {
      to: `/${getUrlProps.adminUser}/outbound-liveagent`,
      icon: sidebarMenuCallIcon,
      title: 'Outbound Live Agent Call',
      fontIcon: fontIconName,
    },
  ]
  const leadGenSidebarContent = [
    {
      to: `/${getUrlProps.adminUser}/customer-list`,
      icon: sidebarClientIcon,
      title: 'Customer List',
      fontIcon: fontIconName,
    },
    {
      to: `/${getUrlProps.adminUser}/customer-script`,
      icon: sidebarClientIcon,
      title: 'Script',
      fontIcon: fontIconName,
    },
  ]

  const navigateUser = (userRole: string) => {
    switch (userRole) {
      case adminRoles.TPV_ADMIN: {
        setSidebarMenuData(tpvadminSidebarContent)
        break
      }
      case adminRoles.AGENT_ADMIN: {
        setSidebarMenuData(agentReport ? sparkagentSidebarContent : agentSidebarContent)
        break
      }
      case adminRoles.SYSTEM_ADMIN: {
        if (!isLeadgen) {
          setSidebarMenuData(systemAdminSidebarContent)
        } else {
          setSidebarMenuData(leadGenSidebarContent)
        }
        break
      }
      case adminRoles.QC_USER: {
        setSidebarMenuData(qcAdminSidebarContent)
        break
      }
      case adminRoles.SALES_ADMIN: {
        setSidebarMenuData(salesReport ? sparksalesSidebarContent : salesSidebarContent)
        break
      }
      case adminRoles.LIVE_AGENT: {
        setSidebarMenuData(liveagentSidebarContent)
        break
      }
      default: {
        navigate(`/${userRole}`)
      }
    }
  }

  return (
    <>
      {renderSidebar && (
        <>
          {isLeadgen
            ? leadGenSidebarContent?.map((admin: any, index: any) => (
              <SidebarMenuItem
                key={index}
                to={admin.to}
                title={admin.title}
                icon={admin.icon}
                fontIcon={admin.fontIcon}
              />
            ))
            : sidebarMenuData?.map((admin: any, index: any) => (
              <SidebarMenuItem
                key={index}
                to={admin.to}
                title={admin.title}
                icon={admin.icon}
                fontIcon={admin.fontIcon}
              />
            ))}
        </>
      )}
    </>
  )
}

export { SidebarMenuMain }
